export { default as SafeAreaView } from "./SafeAreaView";
